//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import PageNotFound from "../pages/ErrorPage/PageNotFound";

import DashboardLayout from "../layouts/DashboardLayout";
import PrivateRoute from "./PrivateRoute";
import Fleet from "../pages/Fleet";
//@ts-ignore
import {
  VehicleRouterService,
  VehicleCategoryRouterService,
  VehicleTypeRouterService,
} from "@careinfo/vehicle";
//@ts-ignore
import {
  PermissionRequired,
  AccessControl,
} from "@careinfo/permission-required";
//@ts-ignore
import { KmRecordRouterService } from "@careinfo/km-record";
import Map from "../pages/Map";
//@ts-ignore
import { WelcomeRouterService } from "@careinfo/welcome-page-service";
import { getKey } from "../helpers/sessionKey";

const Router = () => {
  const shouldShowWelcome = getKey("shouldShowWelcome");
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        {/* <Route path={"/fleet/overview"} element={<Fleet />} /> */}
        <Route path={"/overview"} element={<Fleet />} />
        <Route
          path={"/"}
          element={
            shouldShowWelcome === "true" || shouldShowWelcome === null ? (
              <WelcomeRouterService />
            ) : (
              <Fleet />
            )
          }
        />
        <Route
          path={"/vehicle"}
          element={
            <AccessControl
              children={<VehicleRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        {/* <Route
          path={"/vehicle-category"}
          element={
            <AccessControl
              children={<VehicleCategoryRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/vehicle-type"}
          element={
            <AccessControl
              children={<VehicleTypeRouterService />}
              allowedPermissions={["can_view_setting"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        /> */}
        <Route
          path={"/km-record"}
          element={
            <AccessControl
              children={<KmRecordRouterService />}
              allowedPermissions={["can_view_kmrecord"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route
          path={"/map"}
          element={
            <AccessControl
              children={<Map />}
              allowedPermissions={["can_view_kmrecord"]}
              renderNoAccess={<PermissionRequired />}
            />
          }
        />
        <Route path="/*" element={<PageNotFound />} />
      </Route>
    </Routes>
  );
};

export default Router;
